import classNames from 'classnames';
import { View, Txt } from 'components';
import { supportLink } from 'config';
import styles from './SupportBlock.module.scss';

/**
 * SupportBlock
 *
 * @return {JSX.Element}
 */
const SupportBlock = ({ className, noMargin }) => {
  return (
    <View
      className={classNames(
        styles.SupportBlock,
        noMargin && styles.SupportBlock__noMargin,
        className,
        `${SupportBlock.displayName}`
      )}
    >
      <Txt regular>
        Need support or just have a question? Contact us{' '}
        <a href={supportLink}>here</a>
      </Txt>
    </View>
  );
};

SupportBlock.displayName = 'SupportBlock';

export default SupportBlock;
